import { instanceOf, string } from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Card, Header } from "semantic-ui-react";
import { FormattedMessage } from "react-intl";
import getUnitId from "../v2/getUnitId";
import ConfiguratorCard from "./ConfiguratorCard";
import { getConfigurators, getProjectId } from "../../selectors";
import Configurator from "../configurator/Configurator";
import { withRouter } from "../../helpers/withRouter";

function ConfiguratorsMenu({ configurators, only3D, projectId, unitId }) {
  const renderConfiguratorCard = configurator => {
    const configuratorId = configurator.id;
    const trigger = (
      <ConfiguratorCard
        key={configuratorId}
        configuratorId={configuratorId}
        roomId={configuratorId}
        configuratorTitle={configurator.title}
      />
    );

    return (
      <Configurator
        key={configuratorId}
        trigger={trigger}
        roomId={configuratorId}
        configuratorId={configuratorId}
      />
    );
  };

  if (only3D) {
    // legacy support: fallback to first configurator if just "true" was given instead
    const configuratorId = configurators.has(only3D)
      ? only3D
      : configurators.values().next().value.id;

    return (
      <Configurator
        configuratorId={configuratorId}
        roomId={configuratorId}
        projectId={projectId}
        unitId={unitId}
        only3D
      />
    );
  }

  return configurators.size === 0 ? null : (
    <div>
      <Header size="large" className="3DHeader">
        <FormattedMessage
          id="configurator.title"
          defaultMessage="3D-Konfigurator"
        />
      </Header>
      <Card.Group
        stackable
        itemsPerRow="3"
        doubling
        data-component="configuratorsMenu"
      >
        {Array.from(configurators.values(), configurator =>
          renderConfiguratorCard(configurator)
        )}
      </Card.Group>
    </div>
  );
}

const mapStateToProps = createStructuredSelector({
  configurators: getConfigurators,
  unitId: getUnitId,
  projectId: getProjectId
});

ConfiguratorsMenu.propTypes = {
  unitId: string.isRequired,
  projectId: string.isRequired,
  configurators: instanceOf(Map).isRequired,
  only3D: string
};

ConfiguratorsMenu.defaultProps = {
  only3D: ""
};

export default withRouter(connect(mapStateToProps)(ConfiguratorsMenu));
